import { Button, DialogContent } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Datepicker as MobiScrollDatePicker } from '@mobiscroll/react';
import { useStyles } from './DatePickerComp.styles';
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import { StyledDialog, Typography } from 'shared/elements';

type Props = {
  open: boolean;
  onClose: () => void;
  onChooseDate?: (value: Date[] | Date, valueText?: string) => void;
  type?: 'range' | 'date' | 'preset-range';
  selectMultiple?: boolean;
  handleSetInputText: (value: Date[] | Date) => void;
  defaultValue?: Date[] | Date | undefined;
};
const DatePickerComp: React.FC<Props> = ({
  open,
  onClose,
  onChooseDate,
  type,
  selectMultiple,
  handleSetInputText,
  defaultValue,
}) => {
  const classes = useStyles();
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [valueDate, setValueDate] = useState<Date[] | Date | undefined>(undefined);
  const [valueText, setValueText] = useState<string>('');

  useEffect(() => {
    if (defaultValue) {
      setValueDate(defaultValue);
    }
  }, [defaultValue]);

  const handleChooseDate = () => {
    if (valueDate) {
      if (onChooseDate) {
        if (type === 'range') {
          if (Array.isArray(valueDate)) {
            if (valueDate[1]) {
              onChooseDate(valueDate as Date[], valueText);
              handleSetInputText(valueDate);
              onClose();
            }
          }
        } else {
          onChooseDate(valueDate as Date, valueText);
          handleSetInputText(valueDate);
          onClose();
        }
      }
    }
  };

  return (
    <StyledDialog classes={{ paper: classes.paper }} open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogContent className={classes.dialogContent}>
        {isLoaded && (
          <div className={classes.titleContainer}>
            <Typography fontSize={20}>
              {type === 'range' || type === 'preset-range' ? 'Select Date Range' : 'Select Date'}
            </Typography>
          </div>
        )}

        <MobiScrollDatePicker
          onPageLoaded={() => setIsLoaded(true)}
          theme="material"
          display="inline"
          controls={['calendar']}
          select={type}
          selectMultiple={selectMultiple}
          defaultSelection={valueDate}
          showRangeLabels={false}
          onChange={(e) => {
            const { value, valueText } = e as { value: Date[] | Date; valueText: string };

            setValueDate(value);
            setValueText(valueText);
          }}
          inputProps={{
            placeholder: 'Please Select...',
          }}
          themeVariant="dark"
          className={classes.datePicker}
        />
        {isLoaded && (
          <div className={classes.buttonContainer}>
            <Button color="primary" variant="contained" onClick={() => handleChooseDate()}>
              {type === 'range' || type === 'preset-range' ? 'Choose Date Range' : 'Choose Date'}
            </Button>
          </div>
        )}
      </DialogContent>
    </StyledDialog>
  );
};

export default React.memo(DatePickerComp, (prevProps, nextProps) => prevProps.open === nextProps.open);
